import { AlertTriangle } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Alert, AlertTitle } from "@/components/ui/alert";

interface Props {
  svcs: { code: string; name: string }[];
}

export const SvcList = ({ svcs }: Props) => (
  <div className="mb-6">
    <Label className="block mb-3 text-lg font-medium">
      Zonas disponibles
    </Label>
    {svcs.length === 0 ? (
      <Alert>
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>No hay zonas disponibles</AlertTitle>
        <p className="text-sm">
          No se encontraron zonas asignadas a su usuario. Contacte al
          administrador.
        </p>
      </Alert>
    ) : (
      <div className="bg-primary-soft border-2 border-primary/30 rounded-lg p-4">
        <p className="text-sm text-gray-700 mb-2">
          Se creará disponibilidad automáticamente para todas tus zonas asignadas:
        </p>
        <div className="grid grid-cols-1 gap-2">
          {svcs.map((svc) => (
            <div
              key={svc.code}
              className="flex items-center space-x-3 p-2 bg-white rounded border border-primary/30"
            >
              <span className="font-medium text-sm">{svc.name} ({svc.code})</span>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);
